/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const spainGeneralData = {
  population: '47,615,034 (July 1, 2022)',
  laborForce: '23,381,993 (2021)',
  unemploymentRate: '12.67%',
  gdpPerCapita: '24,590 euros (2022, provisional)'
};
export const spainPurchasingPowerProvinces = [{
  name: 'Araba/Alava',
  value: 20305
}, {
  name: 'Gipuzkoa',
  value: 19225
}, {
  name: 'Madrid',
  value: 18262
}, {
  name: 'Spain Average',
  value: 14636
}, {
  name: 'EU Average',
  value: 14739
}];
export const consumerExpenditureClothing2021 = [{
  name: 'Clothing',
  value: 17455.1
}, {
  name: 'Footwear',
  value: 6086.3
}];
export const euClothingSpendingComparison = [{
  name: 'EU Average',
  value: 490
}, {
  name: 'Spain',
  value: 330
}];
export const textileSectorData = [{
  year: '2019',
  companies: 8282,
  employment: 135,
  turnover: 10472,
  imports: 21823,
  exports: 17064,
  balance: -4759
}, {
  year: '2020',
  companies: 8119,
  employment: 129,
  turnover: 8970,
  imports: 19937,
  exports: 13804,
  balance: -6134
}, {
  year: '2021',
  companies: 7957,
  employment: 128,
  turnover: 10468,
  imports: 20391,
  exports: 17646,
  balance: -2927
}, {
  year: '2022',
  companies: 7823,
  employment: 131,
  turnover: 11850,
  imports: 26938,
  exports: 19721,
  balance: -7217
}];
export const apparelTradeData = [{
  year: '2019',
  exports: 12644.8,
  imports: 15473.6
}, {
  year: '2020',
  exports: 9483.2,
  imports: 12185.0
}, {
  year: '2021',
  exports: 11861.1,
  imports: 14710.3
}];
export const employmentByCategory2021 = [{
  name: 'Apparel',
  value: 46068
}, {
  name: 'Footwear',
  value: 27987
}, {
  name: 'Knitted and Crocheted Articles',
  value: 7859
}, {
  name: 'Luggage, Handbags and Saddlery',
  value: 7818
}, {
  name: 'Fur and Fur Articles',
  value: 436
}];
export const topSpanishBrands2021 = [{
  name: 'Zara',
  rank: 1,
  company: 'Inditex'
}, {
  name: 'Primark',
  rank: 2,
  company: 'Associated British Foods'
}, {
  name: 'Nike',
  rank: 3,
  company: 'Nike Inc'
}, {
  name: 'Bershka',
  rank: 4,
  company: 'Inditex'
}, {
  name: 'adidas',
  rank: 5,
  company: 'adidas Group'
}];
export const popularShoppingDestinations = [{
  name: 'Zara',
  avgTicket: 47,
  type: 'Fast Fashion'
}, {
  name: 'Primark',
  avgTicket: 28,
  type: 'Fast Fashion'
}, {
  name: 'Vinted',
  avgTicket: 23.5,
  type: 'Resale Platform'
}, {
  name: 'Zalando',
  avgTicket: 35,
  type: 'Marketplace'
}, {
  name: 'Shein',
  avgTicket: 25,
  type: 'Online Retailer'
}];
export const ecommerceGrowthData = [{
  year: '2020',
  fashionShoppers: 10.6
}, {
  year: '2021',
  fashionShoppers: 13.2
}];
export const europeEcommerceRanking = [{
  name: 'United Kingdom',
  value: 236
}, {
  name: 'France',
  value: 112
}, {
  name: 'Germany',
  value: 93.6
}, {
  name: 'Spain',
  value: 68.4
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    ol: "ol",
    li: "li",
    em: "em"
  }, _provideComponents(), props.components), {ChartGrid} = _components;
  if (!ChartGrid) _missingMdxReference("ChartGrid", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          }), _jsx(_components.th, {
            children: "Source"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "47,615,034 (July 1, 2022)"
          }), _jsx(_components.td, {
            children: "INEbase, January 2023"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force:"
            })
          }), _jsx(_components.td, {
            children: "23,381,993 (2021)"
          }), _jsx(_components.td, {
            children: "World Bank Open Data, January 2023"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate:"
            })
          }), _jsx(_components.td, {
            children: "12.67%"
          }), _jsx(_components.td, {
            children: "INE, January 2023"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Real GDP per capita:"
            })
          }), _jsx(_components.td, {
            children: "24,590 euros (2022, provisional)"
          }), _jsx(_components.td, {
            children: "Eurostat, January 2023"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Spain: the economy, household income and purchasing power"
    }), "\n", _jsx(_components.h3, {
      children: "Economy"
    }), "\n", _jsx(_components.p, {
      children: "Spain's economy is ranked as the fourth largest within the European Union based on nominal GDP and is also the 14th largest in the world."
    }), "\n", _jsx(_components.p, {
      children: "Source: European Commission website 'Labour market information: Spain' & Investopedia article 'The Top 25 Economies in the World', based on The World Bank data GDP 2020. Last updated in September, 2022"
    }), "\n", _jsx(_components.p, {
      children: "Spain contributed 8.4% to the GDP in the European Union in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS in an article in July 2021 based on information by Eurostat"
    }), "\n", _jsx(_components.h3, {
      children: "Household income"
    }), "\n", _jsx(_components.p, {
      children: "Household disposable income per inhabitant of Spain, adjusted for price levels, amounted to 20,300 euros per inhabitant in 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS in an article in July 2021 based on information by Eurostat (Adjusted gross disposable income of households per capita in PPS)"
    }), "\n", _jsx(_components.h3, {
      children: "Purchasing power"
    }), "\n", _jsx(_components.p, {
      children: "Spain has an average purchasing power of 14,636 euros per capita for spending and savings in 2019, more or less the same as the European average (which is 14,739 euros)."
    }), "\n", _jsx(BarChart, {
      data: spainPurchasingPowerProvinces,
      title: "Purchasing Power by Spanish Provinces 2019 (euros per capita)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Differences in purchasing power around the country: Araba/Alava takes the first place in the purchasing power rankings for Spain's provinces. The capital city province of Madrid has a per capita purchasing power of 18,262 euros. Spain's least affluent provinces are all located in the south-western part of the country."
    }), "\n", _jsx(_components.p, {
      children: "Source: GfK Purchasing Power Europe 2019, October 2019."
    }), "\n", _jsx(_components.h2, {
      children: "Spanish clothing consumption / household expenditure on clothing and footwear"
    }), "\n", _jsx(_components.h3, {
      children: "Consumer Expenditure on Clothing and Footwear"
    }), "\n", _jsx(BarChart, {
      data: consumerExpenditureClothing2021,
      title: "Spanish Consumer Expenditure 2021 (millions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "M"
    }), "\n", _jsx(_components.p, {
      children: "Source: Euromonitor International to FashionUnited exclusively upon request, December 2022."
    }), "\n", _jsx(_components.p, {
      children: "On average, Spaniards spend 330 euros per year on clothing. The European average amount is 490 euros."
    }), "\n", _jsx(BarChart, {
      data: euClothingSpendingComparison,
      title: "Annual Clothing Spending: Spain vs EU Average (euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€"
    }), "\n", _jsx(_components.p, {
      children: "Source: Eurostat, Facts & Key Figures 2022 Euratex report. Source: EU household consumption of clothing in 2020, source Eurostat."
    }), "\n", _jsx(_components.p, {
      children: "Spanish household expenditure on clothing & footwear as % of total expenditure, was 3.3% in 2020. For comparison: the European Union percentage on clothing and footwear is 4.1%"
    }), "\n", _jsx(_components.p, {
      children: "Source: Household expenditure by category, European Union, 2020 (as % of total expenditure), Eurostat."
    }), "\n", _jsx(_components.p, {
      children: "In 2018, Spain was the fifth largest consumer of clothing in the European Union (see more in the tab 'European Union')."
    }), "\n", _jsx(_components.p, {
      children: "Source: Consumer spending on clothing in the European Union 2018, by country, Statista, July 2021"
    }), "\n", _jsx(_components.h2, {
      children: "The Spanish Fashion Industry"
    }), "\n", _jsx(_components.h3, {
      children: "Data of Spain's textile sector in 2022"
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(LineChart, {
        data: textileSectorData,
        title: "Spanish Textile Sector Turnover 2019-2022 (millions euros)",
        dataKey: "turnover",
        xAxisKey: "year",
        valuePrefix: "€",
        valueSuffix: "M"
      }), _jsx(LineChart, {
        data: textileSectorData,
        title: "Spanish Textile Sector Employment 2019-2022 (thousands)",
        dataKey: "employment",
        xAxisKey: "year",
        valueSuffix: "K"
      })]
    }), "\n", _jsx(LineChart, {
      data: textileSectorData,
      title: "Spanish Textile Trade Balance 2019-2022 (millions euros)",
      dataKey: "balance",
      xAxisKey: "year",
      valuePrefix: "€",
      valueSuffix: "M",
      yDomain: [-8000, 0]
    }), "\n", _jsx(_components.p, {
      children: "Source: Texfor provided on request to FashionUnited. Via press Texfor."
    }), "\n", _jsx(_components.h3, {
      children: "Fashion is an important sector"
    }), "\n", _jsx(_components.p, {
      children: "The fashion industry is considered to be one of the most important and strategic sectors in Spain, with significant importance in both the country's domestic economy and export market."
    }), "\n", _jsx(_components.p, {
      children: "The Spanish fashion industry reached a record-breaking international sales, totaling 25,911 million euros, in 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: Gedeth.com 'Recovery of the Spanish fashion sector (I)' by Laura Perez, July 2021."
    }), "\n", _jsx(_components.h2, {
      children: "Spain Apparel Export & Import"
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(LineChart, {
        data: apparelTradeData,
        title: "Spanish Apparel Trade 2019-2021 (millions USD)",
        dataKey: "exports",
        xAxisKey: "year",
        valuePrefix: "$",
        valueSuffix: "M",
        valueLabel: "Exports"
      }), _jsx(LineChart, {
        data: apparelTradeData,
        title: "Spanish Apparel Imports 2019-2021 (millions USD)",
        dataKey: "imports",
        xAxisKey: "year",
        valuePrefix: "$",
        valueSuffix: "M",
        valueLabel: "Imports"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Source: Euromonitor International to FashionUnited exclusively upon request. Industrial: Euromonitor from trade sources/national statistics, December 2022."
    }), "\n", _jsx(_components.p, {
      children: "In 2020, major trading partners for Spain in textiles and clothing were France, Italy, Portugal, Germany and Poland for exports and China, Bangladesh, Turkey, Morocco and Italy for imports."
    }), "\n", _jsx(_components.p, {
      children: "Source: WITS World Bank 'Spain Textiles and Clothing Exports, imports, tariffs, by country and region 2020'"
    }), "\n", _jsx(_components.h2, {
      children: "Production turnover"
    }), "\n", _jsx(_components.p, {
      children: "Spain Apparel Production turnover MSP in 2021: 6,432.3 EUR million"
    }), "\n", _jsx(_components.p, {
      children: "Source: Euromonitor International to FashionUnited exclusively upon request, December 2022."
    }), "\n", _jsx(_components.h2, {
      children: "Employment: how many people work in Fashion?"
    }), "\n", _jsx(BarChart, {
      data: employmentByCategory2021,
      title: "Employment in Spanish Fashion by Category 2021",
      dataKey: "value",
      xAxisKey: "name",
      valueLabel: "Employees",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Average salary in Apparel stands at 30,751.4 USD per annum."
    }), "\n", _jsx(_components.p, {
      children: "Source: Euromonitor International to FashionUnited exclusively upon request. Industrial: Euromonitor from trade sources/national statistics, December 2022."
    }), "\n", _jsx(_components.h2, {
      children: "Most famous Spanish Fashion Companies"
    }), "\n", _jsx(_components.p, {
      children: "Spain is home to leading fashion brands worldwide, and especially some fast fashion brands/high street retailers are internationally established and recognized."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Inditex: the Spanish fashion giant deserves a special mentioning"
      })
    }), "\n", _jsx(_components.p, {
      children: "Inditex is the parent company of fashion brands Zara, Pull&Bear, Massimo Dutti, Bershka, Stradivarius, Oysho, Zara Home. The company was founded by Amancio Ortega Gaona in 1963 and its headquarters is located in A Coruna, Spain. Ortega is one of the wealthiest clothing retailers in the world, because Inditex is one of the largest apparel retailers worldwide."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Other well known Spanish fashion companies, fashion and clothing brands and Spanish fashion designers include:"
      }), " Puig, Mango, Manolo Blahnik, Loewe, Desigual, Adolfo Dominguez, Ecoalf, Cristobal Balenciaga, Paco Rabanne, Alejandro Gomez Palomo, Bimba y Lola, and Pronovias."]
    }), "\n", _jsx(_components.p, {
      children: "El Corte Ingles is also quite relevant, and the Tendam group (owner of Women'secret, Springfield, Cortefiel, Pedro del Hierro, Hoss Intropia, Slowlove, High Spirits, Dash and Stars, OOTO, Fifty, Hi&Bye)"
    }), "\n", _jsx(_components.h2, {
      children: "Largest fashion companies & clothing brands within Spain across 2021"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Top 5 largest Apparel and Footwear Brands within Spain across 2021 by Retail Value RSP"
      })
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Zara (Inditex, Industria de Diseno Textil SA)"
      }), "\n", _jsx(_components.li, {
        children: "Primark (Associated British Foods Plc)"
      }), "\n", _jsx(_components.li, {
        children: "Nike (Nike Inc)"
      }), "\n", _jsx(_components.li, {
        children: "Bershka (Inditex, Industria de Diseno Textil SA)"
      }), "\n", _jsx(_components.li, {
        children: "adidas (adidas Group)"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Source: Company & Brand Shares within Spain across 2021, provided by Euromonitor International to FashionUnited exclusively upon request, December 2022."
    }), "\n", _jsx(_components.h2, {
      children: "Where do Spanish people shop?"
    }), "\n", _jsx(_components.h3, {
      children: "Zara, main shopping destination among Spaniards"
    }), "\n", _jsx(BarChart, {
      data: popularShoppingDestinations,
      title: "Popular Shopping Destinations in Spain (average ticket euros)",
      dataKey: "avgTicket",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "As for the main companies at which Spanish consumers make their fashion purchases, fast fashion chains are at the top as the stores chosen by the largest number of Spaniards to make their purchases. According to the study conducted by N26, the list of stores chosen by Spaniards to buy their clothes is headed by Zara, followed by Primark and Vinted, with an average purchase ticket of 47, 28 and 23.5 euros, respectively."
    }), "\n", _jsx(_components.p, {
      children: "Source: study conducted by the online bank N26, based on anonymized data from more than 70,000 of its Spanish customers, publication FashionUnited November, 2022."
    }), "\n", _jsx(_components.h2, {
      children: "Spain: physical vs online shopping"
    }), "\n", _jsx(_components.p, {
      children: "\"Spaniards still prefer physical commerce, but shopping habits evolved and they consolidated their profile as omnichannel users,\" said Magda Espuga, co-founder of Kiss Retail, the Barcelona based retail strategy consulting firm, in an interview with Mind Retail.com in January 2022."
    }), "\n", _jsx(_components.h3, {
      children: "How much do the Spanish shop online?"
    }), "\n", _jsx(_components.p, {
      children: "Spain was the 4th country in Europe in terms of e-commerce turnover with 68.4 billion euros in 2021."
    }), "\n", _jsx(BarChart, {
      data: europeEcommerceRanking,
      title: "European E-commerce Turnover 2021 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: European E-commerce Report 2021 from EuroCommerce"
    }), "\n", _jsx(_components.h3, {
      children: "E-Commerce facts & figures"
    }), "\n", _jsx(_components.p, {
      children: "94% of the population in Spain used the internet in 2021. (Spain holds position 14 from all European countries in the ranking) It's forecasted that it will stand at 96% in 2022."
    }), "\n", _jsx(_components.p, {
      children: "The number of e-shoppers in Spain is 74% in 2021. (Spain holds position 20 from all European countries in the ranking). It is forecasted to stand at 73% in 2022."
    }), "\n", _jsx(_components.p, {
      children: "Source: Europe E-commerce Report 2022, E-commerce Europe, June 2022. Source: Eurostat, Statista, United Nations."
    }), "\n", _jsx(_components.h3, {
      children: "Zoom in on fashion e-commerce in Spain"
    }), "\n", _jsx(BarChart, {
      data: ecommerceGrowthData,
      title: "Spanish Fashion E-shoppers Growth (millions)",
      dataKey: "fashionShoppers",
      xAxisKey: "year",
      valueSuffix: "M"
    }), "\n", _jsx(_components.p, {
      children: "The number of people who purchase fashion items online (e-shoppers) increased from 10.6 million in the year 2020 to around 13.2 million in the year 2021. It is the highest growth in the number of clothing, footwear, accessories, and home textiles shoppers registered in recent years in the Iberian country."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statista, Number of Online fashion shoppers in Spain, November 2022"
    }), "\n", _jsx(_components.p, {
      children: "In 2021, apparel was the leading e-commerce sector by revenue in Spain, generating approximately 4.3 billion euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statista 'E-commerce sectors generating the highest revenue in Spain in 2021(in billion euros),' November 2022"
    }), "\n", _jsx(_components.p, {
      children: "The average range of expenditure on clothing items in Spain is very wide. Online fashion consumers normally spend between 50 and 100 euros per order."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statista, November 2022"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Most visited fashion webshops in Spain"
      })
    }), "\n", _jsx(_components.p, {
      children: "Fashion brand Zara, from Inditex, is among the most visited fashion e-commerce websites, with an average of 85 million global visitors per month in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statista Fashion dossier key figures E-commerce, November 2022"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Last update: January 2023."
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
